// removed by extract-text-webpack-plugin
module.exports = {"root":"section-banner--root--2jgKow06","text":"section-banner--text--EguLZyf5","banner-soy":"section-banner--banner-soy--2iaz1Z1a","bannerSoy":"section-banner--banner-soy--2iaz1Z1a","banner-wheat":"section-banner--banner-wheat--2NxjIwLb","bannerWheat":"section-banner--banner-wheat--2NxjIwLb","banner-corn":"section-banner--banner-corn--13rKJPAQ","bannerCorn":"section-banner--banner-corn--13rKJPAQ","banner-sunflower":"section-banner--banner-sunflower--3zZBZmmr","bannerSunflower":"section-banner--banner-sunflower--3zZBZmmr"};


//////////////////
// WEBPACK FOOTER
// ./components/section-banner/styles.css
// module id = ./components/section-banner/styles.css
// module chunks = 0